module.exports = __webpack_public_path__ + "img/008-planet-earth.f9a03233.svg";